import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { DataTableDirective } from 'angular-datatables';
import { FormGroup, FormBuilder, FormControl, Validators, AbstractControl, ValidatorFn } from '@angular/forms';
import { MatSnackBar } from '@angular/material';
import { Router } from '@angular/router';
import { myFilter } from 'utilities/util';
import { DatosModal, InformacionGrupo, badgeFacturas, FacturasGrupo, InformacionFacturas } from 'app/entities/cobranza';
import { CarteraService } from 'app/services/cartera/cartera.service';
import * as moment from 'moment';
import { AsociarRadicadoComponent } from '../asociar-radicado/asociar-radicado.component';

@Component({
  selector: 'app-llamadas',
  templateUrl: './llamadas.component.html',
  styleUrls: ['./llamadas.component.scss']
})
export class LlamadasComponent implements OnInit {

  // Variables DataTable //
  public tableOpt_rmv = [];
  public tableOpt_vm = [];
  public dtOptions: Array<DataTables.Settings> = [];
  @ViewChild(DataTableDirective, {static: true}) tabla: DataTableDirective;

  public datos_modal: DatosModal;
  newForm: FormGroup;
  public info_grupo: InformacionGrupo;
  public selected_facturas: Array<InformacionFacturas> = [];
  public myFilter = myFilter;
  public badgeFacturas: badgeFacturas;

  /**
   * Constructor
   * 
   * @param datos 
   * @param {CarteraService} _cartera 
   * @param {FormBuilder} _formBuilder 
   * @param {MatDialogRef<LlamadasComponent>} _dialog 
   * @param {MatSnackBar} _snackBar 
   * @param {Router} router 
   * @param {MatDialog} dialog 
   */
  constructor
  (
    @Inject(MAT_DIALOG_DATA) public datos,
    private _cartera: CarteraService,
    private _formBuilder: FormBuilder, 
    public _dialog: MatDialogRef<LlamadasComponent>, 
    private _snackBar: MatSnackBar, 
    private router: Router,
    private dialog: MatDialog
  ) 
  {
    this.dtOptions[0] = {
      language: {
          zeroRecords: "Sin Facturas Disponibles",
          infoEmpty: "No hay registros disponibles"
      },
      columns: [
          {
              title: '',
              orderable: false
          },
          {
              title: 'Factura',
              data: 'NoFactura'
          },
          {
              title: 'Nombre',
              data: 'nombre_factura'
          },
          {
              title: 'Fecha',
              data: 'fecha_factura'
          },
          {
              title: 'N° Benef.',
              data: 'numero_beneficiarios'
          },
          {
              title: 'Valor Unit.',
              data: 'valor_unitario'
          },
          {
              title: 'Valor Total',
              data: 'valor_total'
          },
          {
              title: 'Saldo Ant.',
              data: 'saldo_anterior'
          },
          {
              title: 'Nvo. Saldo',
              data: 'nuevo_saldo'
          }
        ], 
        dom: 'Rt',
        order: [3, 'desc']
    }
    this.dtOptions[1] = {
      language: {
          zeroRecords: "Sin Facturas Disponibles",
          infoEmpty: "No hay registros disponibles"
      },
      columns: [
        {
            title: '',
            orderable: false
        },
        {
            title: 'Factura',
            data: 'NoFactura'
        },
        {
            title: 'Nombre',
            data: 'nombre_factura'
        },
        {
            title: 'Fecha',
            data: 'fecha_factura'
        },
        {
            title: 'N° Benef.',
            data: 'numero_beneficiarios'
        },
        {
            title: 'Valor Unit.',
            data: 'valor_unitario'
        },
        {
            title: 'Valor Total',
            data: 'valor_total'
        },
        {
            title: 'Saldo Ant.',
            data: 'saldo_anterior'
        },
        {
            title: 'Nvo. Saldo',
            data: 'nuevo_saldo'
        }
      ], 
      dom: 'Rt',
      order: [3, 'desc']
    }
    this.datos_modal = {
      base_datos: datos.data_base,
      indice_empresa: datos.indice,
      hora: datos.hora,
      search_code: datos.search_code,
      infoGrupo: {
        radicado_grupo: datos.grugru,
        codigo_grupo: datos.grunit,
        radicado_asociado: datos.grugru_asociado
      },
      origen: datos.origen
    }
    this.newForm = this.createForm();
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On Init
   */
  ngOnInit() {
    this._cartera.VerFacturasxGrupo(this.datos_modal.infoGrupo.radicado_grupo, this.datos_modal.infoGrupo.codigo_grupo, this.datos_modal.infoGrupo.radicado_asociado, this.datos_modal.base_datos)
                  .subscribe((data: FacturasGrupo) => {
                                      this.badgeFacturas = {
                                        Medisoft: data.Conteo_frmv,
                                        Medisoftvet: data.Conteo_fvm,
                                        Radicado_rmv: data.Radicado_rmv,
                                        Radicado_vm: data.Radicado_vm
                                      }
                                      this.tableOpt_rmv = data.Facturas_rmv;
                                      this.tableOpt_vm = data.Facturas_vm;
                              });

    this._cartera.VerInfoGrupo(this.datos_modal.search_code, this.datos_modal.search_code, this.datos_modal.base_datos)
                  .subscribe((data: any) => {
                    this.asignarForm(data[0]);
                  });
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Recibe el objeto factura y lo almacena en la variable 'selected_facturas'
   * @param factura 
   */
  public addFacturas(factura): void {
    // Re-construimos la información de la factura 
    const Facturas: InformacionFacturas = {
        Empresa: factura.empresa === "VitalMascotas" ? '2' : '1',
        ID_Grupo: factura.ID_Grupo,
        Radicado_Grupo: factura.radicado,
        NoFactura: factura.NoFactura,
        ID_Factura: factura.id_Factura,
        Nvo_saldo: factura.nuevo_saldo
    }

    // Almacenamos la constante 'Factura' en 'selected_facturas'
    this.selected_facturas.push(Facturas);
  }

  /**
   * Elimina la factura si esta se encuentra duplicada en la variable 'selected_facturas'
   * @param NoFactura 
   */
  public deleteFacturas(NoFactura): void {
    let index: number = this.selected_facturas.findIndex(Factura => Factura.NoFactura === NoFactura);
    this.selected_facturas.splice(index, 1);
  }

  /**
   * Guarda la información de la llamada.
   * @param form 
   */
  public guardarLlamada(form){

    // Condición: Si el formulario tiene como estado inválido, se retorna
    if(this.newForm.status === 'INVALID'){
      this._snackBar.open('Error: Campos Incompletos', '', {
        duration: 2000,
        panelClass: 'warn-600'
      });
      return;
    }

    // Condición: Si en la variable form['llamada'] existe devolver_llamada, se le aplica un formato a la fecha 
    if(form['llamada'].devolver_llamada){
      form['llamada'].devolver_llamada = moment(form['llamada'].devolver_llamada).format('YYYY-MM-DD');
    }

    // Se agregan las facturas seleccionadas a form['facturas_llamada']
    form['facturas_llamada'] = this.selected_facturas;

    this._cartera.GuardarLlamada(form).subscribe((data: any) => {
      // Condición: Si columnas afectadas es mayor a cero(0), muestra un mensaje de aprovación y se cierra el modal, de lo contrario, sale un mensaje de error
      if(data['affectedRows'] > 0){
        this._snackBar.open('Llamada Guardada', 'Aceptar', {
          duration: 2000
        });
        this._dialog.close(true);
      }else{
        this._snackBar.open('Error al guardar la llamada', '', {
          panelClass: ['warn-600'],
          duration: 2000
        });
      }
    });
  }

  /**
   * Creación del FormGroup
   * 
   * @returns {FormGroup}
   */
  createForm(): FormGroup
  {
    return new FormGroup({
      informacionGrupo:  this._formBuilder.group({
        database: new FormControl(this.datos_modal.base_datos),
        ID_grupo: new FormControl(),
        empresa: new FormControl(this.datos_modal.indice_empresa),
        radicado: new FormControl(this.datos_modal.infoGrupo.radicado_grupo),
        ciclo: new FormControl()
      }),
      tipo_factura: this._formBuilder.group({
        fact_fisica: new FormControl(),
        fact_elect: new FormControl()
      }),
      telefono: new FormControl('',[
        Validators.pattern('^[0-9- ]{0,18}$')
      ]),
      celular: new FormControl('',[
        Validators.pattern('^[0-9- ]{0,18}$')
      ]),
      llamada: this._formBuilder.group({
        responsable: new FormControl('', [
          Validators.required
        ]),
        hora: new FormControl(this.datos_modal.hora),
        tipodecomunicacion: new FormControl(''),
        gestiondepago: new FormControl(''),
        actividad: new FormControl('',[]),
        devolver_llamada: new FormControl()
      }),
      observaciones: this._formBuilder.group({
        cartera: new FormControl(),
        llamada: new FormControl(),
        contrato: new FormControl()
      }),
      facturas_llamada: new FormControl(),
      usuario: new FormControl(JSON.parse(localStorage.getItem('usuario'))['id_usuario'])
    });
  }

  /**
   * Se asigna valores al FormGroup y al info_grupo
   * @param data 
   */
  asignarForm(data): void{
    this.newForm.patchValue({
      informacionGrupo: {
        ID_grupo: data.id_grupo,
        ciclo: data.ciclo_grupo
      },
      tipo_factura: {
        fact_fisica: data.factura_fisica === '0' ? false : true,
        fact_elect: data.factura_elec === '0' ? false : true
      },
      telefono: data.telefono_grupo ? data.telefono_grupo : '',
      celular: data.celular_grupo ? data.celular_grupo : '',
      observaciones: {
        cartera: data.observacion_cartera,
        contrato: data.observacion_contrato
      }
    });

    this.info_grupo = {
      ciclo_grupo: data.ciclo_grupo,
      radicado_grupo: data.radicado_grupo,
      codigo_grupo: data.codigo_grupo,
      nvo_saldo: data.nvo_saldo,
      estado_rmv: data.estado_rmv,
      estado_vm: data.estado_vm,
      estado_grupo: data.estado_grupo,
      nombre_grupo: data.nombre_grupo
    }
  }

  /**
   * Enruta hacia el calendario
   * 
   * @param {any} form 
   */
  onRouterAgendaCobro(form: any): void {
    this.router.navigate(
                          [`cobranza/cartera/${(this.datos_modal.origen === 'fijos' ? 'cobros-fijos' : 'cobros-ocasionales')}/agenda-calendario`, 
                          this.datos_modal.origen === 'fijos' ? 'llamada-fij' : 'llamada-oca', 
                          this.datos_modal.indice_empresa, 
                          this.datos_modal.base_datos, 
                          this.datos_modal.search_code]
                        ).then(() => {
                              this._dialog.close();
                            }
                        );
    localStorage.setItem('Llamada', JSON.stringify(form));
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Modals
  // -----------------------------------------------------------------------------------------------------

  /**
   * Abre modal RadicadoAsoc, encargado de la búsqueda del grupo del cual se desea asociar el radicado
   * al grupo en cuestión, al cerrarse, se devuelve el radicado a asociar.
   * @param {string} radicado 
   */
  public modalRadicadoAsoc(radicado: string): void {
    const Database: string = this.datos_modal.base_datos === 'medisoft' ? 'medisoftvet' : 'medisoft';
    let asociar_Radicados: Array<{Database: string, Radicado: string, Rad_asoc: string}> = []
    
    let modal: any;
    modal = this.dialog.open(AsociarRadicadoComponent, {
        width: '40vw',
        data: {
            Database: Database
        }
    });

    modal.afterClosed().subscribe((radicado_asoc: string) => {
        if(radicado_asoc){
            asociar_Radicados.push({
                Database: this.datos_modal.base_datos,
                Radicado: radicado,
                Rad_asoc: radicado_asoc
            }, 
            {
                Database: Database,
                Radicado: radicado_asoc,
                Rad_asoc: radicado
            });
            this._cartera.AgregarRadicadoAsoc(asociar_Radicados).subscribe((data: any) => {
                if(data['changedRows'] > 0 && data['affectedRows'] >= 1){
                    this._snackBar.open(`Radicado Asociado`, 'Aceptar', {
                        duration: 2000
                    });
                }else if(data['changedRows'] === 0 && data['affectedRows'] >= 1){
                    this._snackBar.open('Radicado ya asociado', '', {
                        duration: 2500,
                        panelClass: 'yellow'
                    });
                }else{
                    this._snackBar.open('Error al asociar el radicado', '', {
                        duration: 2500,
                        panelClass: 'warn-600'
                    });
                } 
            });
        }
    });
  }
}
